import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const PersonCourseAdminIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M0.833328 14V12.667C0.833328 11.8271 1.1672 11.0216 1.76106 10.4277C2.35493 9.83387 3.16047 9.5 4.00032 9.5H6.66634C6.94248 9.5 7.16634 9.72386 7.16634 10C7.16634 10.2761 6.94248 10.5 6.66634 10.5H4.00032C3.42568 10.5 2.87442 10.7284 2.46809 11.1348C2.06176 11.5411 1.83333 12.0924 1.83333 12.667V14C1.83333 14.2761 1.60947 14.5 1.33333 14.5C1.05719 14.5 0.833328 14.2761 0.833328 14Z"
      fill="currentColor"
    />
    <path
      d="M8.97599 11.9512C9.2948 11.8192 9.66026 11.9704 9.79239 12.2891C9.92436 12.6079 9.77327 12.9734 9.4545 13.1055L8.83927 13.3604C8.5205 13.4923 8.15504 13.3411 8.02286 13.0225C7.89087 12.7035 8.04186 12.3371 8.36075 12.2051L8.97599 11.9512Z"
      fill="currentColor"
    />
    <path
      d="M8.02286 10.5034C8.15513 10.1847 8.5205 10.0334 8.83927 10.1655L9.4545 10.4204C9.77332 10.5527 9.92469 10.919 9.79239 11.2378C9.66004 11.5563 9.29464 11.7077 8.97599 11.5757L8.36075 11.3198C8.042 11.1876 7.89071 10.8222 8.02286 10.5034Z"
      fill="currentColor"
    />
    <path
      d="M9.8035 8.72266C10.1223 8.59051 10.4876 8.7418 10.6199 9.06055L10.8758 9.67579C11.0078 9.99444 10.8564 10.3598 10.5379 10.4922C10.2191 10.6245 9.85279 10.4731 9.7205 10.1543L9.46561 9.53907C9.33346 9.22029 9.48475 8.85493 9.8035 8.72266Z"
      fill="currentColor"
    />
    <path
      d="M9.7205 13.3721C9.85267 13.0532 10.219 12.902 10.5379 13.0342C10.8564 13.1665 11.0078 13.5319 10.8758 13.8506L10.6199 14.4668C10.4877 14.7855 10.1223 14.9368 9.8035 14.8047C9.48469 14.6725 9.33355 14.3071 9.46561 13.9883L9.7205 13.3721Z"
      fill="currentColor"
    />
    <path
      d="M11.5065 9.06056C11.6388 8.74174 12.0051 8.59038 12.3239 8.72267C12.6424 8.855 12.7938 9.22043 12.6618 9.53908L12.4059 10.1543C12.2736 10.4731 11.9083 10.6244 11.5895 10.4922C11.2707 10.3599 11.1194 9.99459 11.2516 9.6758L11.5065 9.06056Z"
      fill="currentColor"
    />
    <path
      d="M11.5895 13.0342C11.9083 12.9024 12.2738 13.0535 12.4059 13.3721L12.6608 13.9883C12.7927 14.3073 12.6409 14.6728 12.3219 14.8047C12.003 14.9364 11.6374 14.7847 11.5055 14.4658L11.2516 13.8506C11.1198 13.5318 11.2709 13.1662 11.5895 13.0342Z"
      fill="currentColor"
    />
    <path
      d="M13.2884 10.1655C13.6072 10.0335 13.9726 10.1846 14.1048 10.5034C14.2369 10.8222 14.0856 11.1876 13.7669 11.3198L13.1507 11.5757C12.832 11.7077 12.4666 11.5563 12.3343 11.2378C12.2021 10.9189 12.3533 10.5526 12.6721 10.4204L13.2884 10.1655Z"
      fill="currentColor"
    />
    <path
      d="M12.3343 12.2891C12.4664 11.9702 12.8318 11.819 13.1507 11.9512L13.7669 12.2061C14.0857 12.3382 14.2369 12.7046 14.1048 13.0234C13.9725 13.3419 13.607 13.4932 13.2884 13.3613L12.6721 13.1055C12.3533 12.9733 12.2021 12.6079 12.3343 12.2891Z"
      fill="currentColor"
    />
    <path
      d="M12.1004 11.7C12.1004 11.0649 11.5851 10.5496 10.95 10.5496C10.3149 10.5496 9.79959 11.0649 9.79959 11.7C9.79959 12.3351 10.3149 12.8504 10.95 12.8504C11.5851 12.8504 12.1004 12.3351 12.1004 11.7ZM13.2996 11.7C13.2996 12.9979 12.2479 14.0496 10.95 14.0496C9.65211 14.0496 8.60037 12.9979 8.60037 11.7C8.60037 10.4021 9.65211 9.3504 10.95 9.3504C12.2479 9.3504 13.2996 10.4021 13.2996 11.7Z"
      fill="currentColor"
    />
    <path
      d="M8.16634 4.66699C8.16634 3.47048 7.19679 2.50018 6.00032 2.5C4.8037 2.5 3.83333 3.47038 3.83333 4.66699C3.8335 5.86346 4.80381 6.83301 6.00032 6.83301C7.19668 6.83283 8.16616 5.86335 8.16634 4.66699ZM9.16634 4.66699C9.16616 6.41564 7.74896 7.83283 6.00032 7.83301C4.25153 7.83301 2.8335 6.41574 2.83333 4.66699C2.83333 2.91809 4.25142 1.5 6.00032 1.5C7.74907 1.50018 9.16634 2.9182 9.16634 4.66699Z"
      fill="currentColor"
    />
  </svg>
);
